import { useContext, useEffect, useState, useCallback, useReducer } from "react";
import { useSearchParams } from 'react-router-dom';
import debounce from 'lodash/debounce';
import {TextField, Autocomplete} from '@mui/material';

import SearchContext from 'src/context/SearchContext';

const SearchBox = () => {
    const {autocomplete} = useContext(SearchContext);
    const [searchParams, setSearchParams] = useSearchParams();
    const [query, setQuery] = useState(searchParams.get('query')?.trim() || '');
    const [suggestions, setSuggestions] = useState([]);

    const updateSP = (query) => {
        if (query) searchParams.set('query', query);
        else searchParams.delete('query');
        setSearchParams(searchParams);
    }

    // https://stackoverflow.com/a/66652147
    const [inputValue, setInputValue] = useState("");
    const getOptionsDelayed = useCallback(
        debounce((text, callback) => {
            setSuggestions([]);
            autocomplete(text).then(callback);
        }, 250),
        []
    );
    useEffect(() => {
        getOptionsDelayed(inputValue, (filteredOptions) => {
            setSuggestions(filteredOptions);
        });
    }, [inputValue, getOptionsDelayed]);

    const hChange = (ev, query, reason) => {
        if (reason != 'clear') {
            updateSP(query);
        }
    }

    useEffect(() => {
        setQuery(searchParams.get('query')?.trim() || '');
    }, []);

    const renderInput = (params) => (
        <TextField {...params}
            name='query'
            placeholder="Buscar..."
            inputProps={{
                ...params.inputProps,
                onKeyDown: (e) => {
                    // hack, autocomplete lanza onChange cuando se limpia la cadena, queremos que lo haga en el enter
                    if (e.key === 'Enter' && !e.target.value) {
                        updateSP(e.target.value)
                    }
                },
            }}
        />
    );

    return (
        <div id="search-box" className="search-box">
            <Autocomplete
                options={suggestions}
                renderInput={renderInput}
                autoComplete
                clearOnEscape
                disablePortal
                filterOptions={(x) => x} // you will need to disable the built-in filtering
                forcePopupIcon={false}
                freeSolo
                id='search-prompt'
                noOptionsText="No se encontró ninguna sugerencia"
                onChange={hChange}
                onInputChange={(e, newInputValue) => setInputValue(newInputValue)}
                defaultValue={query}
            />

            <i className="search icon lupa" onClick={() => updateSP()}></i>
        </div>
    );
};

export default SearchBox;
